module.exports = __webpack_public_path__ + "media/images/front/columns_test_img_06-5bac52c713d63d2b98a092e7d4303d9c.png";